import axios from "axios";
import { NewProduct } from "models/new_product_type";
import { PessoaType } from "models/person_type";
import { UsuarioModel } from "models/user_model";
import { useEffect, useRef, useState } from "react";

const useNewProduct = () => {
  const [list, setAccountTypeList] = useState<NewProduct[]>([]);
  const [usuario, setUsuario] = useState<UsuarioModel>();
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [errorTitle, setErrorTitle] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [error, setError] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [accountSelected, setAccountSelected] = useState<NewProduct>(null);
  const [fornecedores, setFornecedores] = useState<PessoaType[]>([]);
  const [selectedFornecedor, setSelectedFornecedor] = useState<PessoaType[]>(
    []
  );
  const cancelRef = useRef();

  const cleanInput = () => {
    setSelectedFornecedor([]);
    setAccountSelected(null);
  };

  const add = () => {
    showModal(true);
  };

  const edit = (item: NewProduct) => {  
    showModal(true);
    setAccountSelected(item);

    const newData =   item?.NovoProdutoFornecedor?.map((fr) => (
      fr.pessoaId
    ))
      if(newData?.length > 0) {
        const persons =  fornecedores.filter((pr) => newData.includes(pr.id));
        setSelectedFornecedor(persons);
      }
  };

  const validateField = (condition: any, errorMessage: string) => {
    if (!condition) {
      showError("Erro!", errorMessage);
      return false;
    }
    return true;
  };
  
  const validate = () => {
    let response = true;
    response = validateField(accountSelected?.nome, "Preencha o Campo Nome Corretamente") && response;
    response = validateField(accountSelected?.sku, "Preencha o Campo SKU Corretamente") && response;
    response = validateField(accountSelected?.precoVenda, "Preencha o Campo Preço Corretamente") && response;
    response = validateField(accountSelected?.marca, "Preencha o Campo Marca Corretamente") && response;
    response = validateField(accountSelected?.modelo, "Preencha o Campo Modelo Corretamente") && response;
    response = validateField(selectedFornecedor.length > 0, "Selecione ao menos um Fornecedor para o Produto") && response;

    return response;
  }

  const save = async () => {

    if (validate()) {
      setLoading(true);
      if (accountSelected?.id === undefined) {
        await addRegister();
      } else {
        await updateRegister();
      }
      setLoading(false);
      showModal(false);
      cleanInput();
      await loadData()
    }
  };

  const addRegister = async () => {

    const obj = {
      ativo: true,
      condicao: accountSelected?.condicao,
      dataValidade: accountSelected?.dataValidade ?? new Date(),
      depreciacao: accountSelected?.depreciacao ?? '',
      formato: accountSelected?.formato ?? '',
      idEmpresa: usuario?.idEmpresa,
      marca: accountSelected?.marca ?? '',
      modelo: accountSelected?.modelo ?? '',
      ncm: accountSelected?.ncm ?? '',
      numSerie: accountSelected?.numSerie ?? '',
      nome: accountSelected?.nome,
      precoVenda: accountSelected?.precoVenda,
      sku: accountSelected?.sku,
      tipo: accountSelected?.tipo,
      unidadeMedidaId: accountSelected?.unidadeMedidaId,

    };
    const response = await axios.post(
      process.env.REACT_APP_API_URL + "/novo-produto/",
      obj
    );
    if(response.data) {
      const item : NewProduct = response.data;
      if(selectedFornecedor?.length > 0) {
        for (let i = 0; i < selectedFornecedor?.length; i++) {
          const element = selectedFornecedor[i];
          const itemData  = {
            novoProdutoId : item.id,
            pessoaId: element.id
          }
          await axios.post(process.env.REACT_APP_API_URL + "/novo-produto/fornecedor", itemData);
        }
      }
      setLoading((prev) => (prev = false));
      cleanInput();
      showModal(false);
    }
  }

  const updateRegister = async () => {

    const obj = {
      id: accountSelected?.id,
      ativo: true,
      condicao: accountSelected?.condicao,
      dataValidade: accountSelected?.dataValidade ?? new Date(),
      depreciacao: accountSelected?.depreciacao ?? '',
      formato: accountSelected?.formato ?? '',
      idEmpresa: usuario?.idEmpresa,
      marca: accountSelected?.marca ?? '',
      modelo: accountSelected?.modelo ?? '',
      ncm: accountSelected?.ncm ?? '',
      numSerie: accountSelected?.numSerie ?? '',
      nome: accountSelected?.nome,
      precoVenda: accountSelected?.precoVenda,
      sku: accountSelected?.sku,
      tipo: accountSelected?.tipo,
      unidadeMedidaId: accountSelected?.unidadeMedidaId,

    };
    const response = await axios.patch(
      process.env.REACT_APP_API_URL + "/novo-produto/" + accountSelected?.id,
      obj
    );
    if(response.data) {
      const item : NewProduct = response.data;

      if(accountSelected?.NovoProdutoFornecedor?.length > 0) {
        for (let i = 0; i < accountSelected?.NovoProdutoFornecedor?.length; i++) {
          const removeItem = accountSelected?.NovoProdutoFornecedor[i];
          await axios.delete(process.env.REACT_APP_API_URL + "/novo-produto/fornecedor/" + removeItem.id);
        }
      }

      if(selectedFornecedor?.length > 0) {
        for (let i = 0; i < selectedFornecedor?.length; i++) {
          const element = selectedFornecedor[i];
          const itemData  = {
            novoProdutoId : item.id,
            pessoaId: element.id
          }
          await axios.post(process.env.REACT_APP_API_URL + "/novo-produto/fornecedor", itemData);
        }
      }
      setLoading((prev) => (prev = false));
      cleanInput();
      showModal(false);
    }

  }

  const deletar = async () => {
    const response = await axios.delete(
      process.env.REACT_APP_API_URL + "/novo-produto/" + accountSelected?.id
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      showModal(false);
      setAccountSelected(null);
      setShowDelete(false);
      await loadData();
    }
  };

  const showModal = (show: boolean) => {
    setShow(show);
    setError(false);
    if (!show) {
      cleanInput();
    }
  };

  const loadData = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/novo-produto/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setAccountTypeList(response.data);
    }
  };

  const loadFornecedores = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/projeto/fornecedor/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setFornecedores(response.data);
    }
  };

  const showDeleteModal = (item: NewProduct) => {
    setShowDelete(true);
    setAccountSelected(item);
  };

  const closeDelete = () => {
    setShowDelete(false);
  };

  const closeError = () => {
    setError(false);
  };

  const showError = (title: string, msg: string) => {
    setError(true);
    setErrorTitle(title);
    setErrorMsg(msg);
  };

  const changeInput = (type: string, value: any) => {
    switch (type) {
      case "nome":
        setAccountSelected({ ...accountSelected, nome: value });
        break;
      case "sku":
        setAccountSelected({ ...accountSelected, sku: value });
        break;
      case "precoVenda":
        setAccountSelected({ ...accountSelected, precoVenda: value });
        break;
      case "marca":
        setAccountSelected({ ...accountSelected, marca: value });
        break;
      case "modelo":
        setAccountSelected({ ...accountSelected, modelo: value });
        break;
      case "dataValidade":
        setAccountSelected({ ...accountSelected, dataValidade: value });
        break;
      case "ncm":
        setAccountSelected({ ...accountSelected, ncm: value });
        break;
      case "numSerie":
        setAccountSelected({ ...accountSelected, numSerie: value });
        break;
      case "depreciacao":
        setAccountSelected({ ...accountSelected, depreciacao: value });
        break;
      case "unidade":
        setAccountSelected({ ...accountSelected, unidadeMedidaId: value });
        break;
      case "formato":
        setAccountSelected({ ...accountSelected, formato: value });
        break;
      case "tipo":
        setAccountSelected({ ...accountSelected, tipo: value });
        break;
      case "condicao":
        setAccountSelected({ ...accountSelected, condicao: value });
        break;
    }
  };

  const changeFornecedor = (item: any[]) => {
    const list: PessoaType[] = [];
    item?.forEach((val) => {
      const existe = selectedFornecedor?.find(
        (valor) => valor.id === val?.value
      );
      if (!existe) {
        const item = fornecedores?.find((it) => it?.id === val?.value);
        list.push(item);
      } else {
        list.push(existe);
      }
    });
    setSelectedFornecedor(list);
  };

  useEffect(() => {
    const initialize = async () => {
      await loadData();
      await loadFornecedores();
    };
    initialize();
  }, []);
  return {
    list,
    add,
    edit,
    loading,
    show,
    showModal,
    accountSelected,
    error,
    save,
    deletar,
    showDeleteModal,
    showDelete,
    closeDelete,
    cancelRef,
    usuario,
    errorTitle,
    errorMsg,
    fornecedores,
    selectedFornecedor,
    loadFornecedores,
    showError,
    closeError,
    changeInput,
    changeFornecedor,
  };
};
export default useNewProduct;
